<template>
    <div class="pagination _board_type" id="list_paginate">
        <!-- 처음 버튼 -->
        <button class="first_btn icon_wrap" :class="{ on: currentPage > 1 }" @click="currentPage > 1 && fnPaging(1)">
            <img src="img/board_first_btn.png" alt="처음" />
        </button>
        <!-- 이전 버튼 -->
        <button class="prev_btn icon_wrap" :class="{ on: currentPage > 1 }" @click="currentPage > 1 && fnPaging(currentPage - 1)">
            <img src="img/board_prev_btn.png" alt="이전" />
        </button>

        <!-- 페이지 번호 -->
        <button v-for="page in visiblePages" :key="page" @click="fnPaging(page)" class="pg_btn" :class="{ active: page === currentPage }">
            {{ page }}
        </button>

        <!-- 다음 버튼 -->
        <button class="next_btn icon_wrap" :class="{ on: currentPage < paging }" @click="currentPage < paging && fnPaging(currentPage + 1)">
            <img src="img/board_prev_btn.png" alt="다음" />
        </button>

        <!-- 마지막 버튼 -->
        <button class="last_btn icon_wrap" :class="{ on: currentPage < paging }" @click="currentPage < paging && fnPaging(paging)">
            <img src="img/board_first_btn.png" alt="마지막" />
        </button>
    </div>
</template>

<script lang="ts">
    import { computed } from "@/BaseComponent";

    export default {
        props: {
            currentPage: { type: Number, required: true },
            totalLength: { type: Number, required: true },
            perPage: { type: Number, required: true },
        },
        emits: ["onPaging"],

        setup(props: any, { emit }: any) {
            const paging = computed(() => Math.max(1, Math.ceil(props.totalLength / props.perPage)));
            const visiblePages = computed(() => {
                const pages = [];
                if (props.currentPage <= 3) {
                    for (let i = 1; i <= Math.min(5, paging.value); i++) {
                        pages.push(i);
                    }
                } else if (props.currentPage >= paging.value - 2) {
                    for (let i = Math.max(1, paging.value - 4); i <= paging.value; i++) {
                        pages.push(i);
                    }
                } else {
                    for (let i = props.currentPage - 2; i <= props.currentPage + 2; i++) {
                        pages.push(i);
                    }
                }
                return pages;
            });

            const fnPaging = (page: number) => {
                emit("onPaging", page);
            };

            return {
                paging,
                visiblePages,
                fnPaging,
            };
        },
    };
</script>

<style scoped></style>
